(function () {
  if (window.__lazyVideoInitialized) return;
  window.__lazyVideoInitialized = true;

  const LOADED_ATTR = 'data-lazy-video-loaded';

  function loadVideo(video) {
    if (video.getAttribute(LOADED_ATTR) === 'true') return;

    const src = video.dataset.src;
    if (!src) return;

    video.src = src;
    video.setAttribute(LOADED_ATTR, 'true');

    if (video.dataset.lazyVideoAutoplay === 'true') {
      video.play().catch(function () {});
    }
  }

  function initLazyVideos(root) {
    const scope = root || document;
    const videos = scope.querySelectorAll('video[data-src]:not([' + LOADED_ATTR + '="true"])');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideo);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    videos.forEach(function (video) {
      var triggerLoad = function () {
        loadVideo(video);
      };
      video.addEventListener('click', triggerLoad, { passive: true });
      video.addEventListener('play', triggerLoad, { once: true });
      observer.observe(video);
    });
  }

  function onReady() {
    initLazyVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initLazyVideos(event.target);
  });
})();
